import React from "react";
import { useParams } from "react-router-dom";

import { useGetProgramSkippedTimelines } from "./dataloader";
import { useParticipantDetails } from "apps/myExperience/context/participantDetails";

export function useAssociatedProgramWorkflowService() {
  const { programParticipantId } = useParams();
  const { getProgramDetails } = useParticipantDetails();
  const { data: skippedTimelineStages } = useGetProgramSkippedTimelines({ programParticipantId });

  const { programStatus } = React.useMemo(() => {
    return {
      programStatus: programParticipantId && getProgramDetails(programParticipantId)?.status
    };
  }, [programParticipantId, getProgramDetails]);

  return { programStatus, skippedTimelineStages };
}
